import { useEffect, useRef } from 'react';

/**
 * WARNING: **YOU MOST LIKELY DO NOT NEED TO USE THIS HOOK**... especially outside of the `dragAndDropEditor` module.
 *
 * Returns a ref that is automatically set to the latest of a given value.
 * - NOTE: the ref does not trigger re-renders and is meant to be used to sync react values/states with non-react contexts (e.g. the bee sdk config).
 */
export function useLatestValueRef<T>(value: T, additionalDependencies: any[] = []) {
  const ref = useRef<T>(value);

  useEffect(() => {
    ref.current = value;
  }, [value, ...additionalDependencies]);

  return ref;
}
